import { OPEN_HELP, CLOSE_HELP } from './types';

export const openHelp = () => dispatch => {
    return dispatch({
        type: OPEN_HELP
    })
}

export const closeHelp = () => dispatch => {
    return dispatch({
        type: CLOSE_HELP
    })
}